<template>
  <div>
    <div class="row mt-2">
      <div class="col-12">
        <div class="col-12 mt-3 mb-2"
             style="font-weight: bold;
             font-size: 18px;
             border-bottom: 1px solid #ddd;">
          {{ title }}
        </div>
      </div>

      <!-- Loop through items and render inputs -->
      <div class="col-12" v-for="(item, index) in items" :key="index">
        <div class="row mt-5">
          <BaseInput v-model="item.id"
                     hidden="hidden"/>

          <div class="col-12">
            <TextEditor
                v-model="item.description"
                @update:model-value="item.description = $event"
                :inputStyle="{ height: '200px' }"
                :label="itemDescriptionLabel"/>
          </div>
        </div>

        <!-- Delete Button -->
        <button
            class="btn btn-danger mt-3"
            v-if="items && items.length > 0"
            @click="deleteItem(index)">
          Löschen
        </button>
      </div>
    </div>
  </div>

  <!-- Add Button -->
  <div class="text-right mb-5">
    <button type="button" class="btn btn-primary" @click="addItem">
      +
    </button>
  </div>
</template>

<script setup>
import BaseInput from '@/components/base/BaseInput.vue';
import TextEditor from '@/components/TextEditor.vue';
import { defineEmits, defineProps } from 'vue';

// Props
defineProps({
  title: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  itemTitleLabel: {
    type: String,
    default: 'Title',
  },
  itemDescriptionLabel: {
    type: String,
    default: 'Description',
  },
  itemSelectPlaceholder: {
    type: String,
    required: false,
    default: 'Wert auswählen',
  },
  dropdownOptions: {
    type: Array,
    default: () => [],
  },
});

// Emits
const emit = defineEmits([ 'addItem', 'deleteItem' ]);

// Helper Methods
const addItem    = () => {
  emit('addItem', { description: '' }); // Default to a regular input
};
const deleteItem = (index) => {
  emit('deleteItem', index);
};
</script>

<style scoped>
/* Add component-specific styles here if necessary */
</style>
